import { useNavigate as useRouterNavigate } from "react-router-dom"
import { useCallback } from "react"

import type { PerpsRoute } from "./Router"
import { renderRoute } from "./utils"

export const useNavigate = () => {
  const navigate = useRouterNavigate()

  return useCallback(
    (route: PerpsRoute) => {
      navigate(renderRoute(route))
    },
    [navigate],
  )
}
